import React from 'react';

import { Button } from '../../../components/MuiGenerals';
import { useTranslation } from '../../../hooks';

interface IProps {
  onClick: () => void;
  isDisabled?: boolean;
}

const RejectButton = ({ onClick, isDisabled }: IProps) => {
  const { tc } = useTranslation();

  return (
    <Button
      className={'inheritColor'}
      color={'primary'}
      variant={'contained'}
      children={tc('reject_btn')}
      onClick={onClick}
      style={{
        width: '160px',
        height: '38px',
        marginRight: '12px',
        backgroundColor: isDisabled ? '#3a3a3a' : '#E86A62',
        color: isDisabled ? '#888888' : '#FFFFFF',
        borderRadius: '8px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.6 : 1,
      }}
      disabled={isDisabled}
    />
  );
};

export default RejectButton;
